const provinces = {
  "กรุงเทพมหานคร": [
    "เขตพระนคร",
    "เขตดุสิต",
    "เขตหนองจอก",
    "เขตบางรัก",
    "เขตบางเขน",
    "เขตบางกะปิ",
    "เขตปทุมวัน",
    "เขตป้อมปราบศัตรูพ่าย",
    "เขตพระโขนง",
    "เขตมีนบุรี",
    "เขตลาดกระบัง",
    "เขตยานนาวา",
    "เขตสัมพันธวงศ์",
    "เขตพญาไท",
    "เขตธนบุรี",
    "เขตบางกอกใหญ่",
    "เขตห้วยขวาง",
    "เขตคลองสาน",
    "เขตตลิ่งชัน",
    "เขตบางกอกน้อย",
    "เขตบางขุนเทียน",
    "เขตภาษีเจริญ",
    "เขตหนองแขม",
    "เขตราษฎร์บูรณะ",
    "เขตบางพลัด",
    "เขตดินแดง",
    "เขตบึงกุ่ม",
    "เขตสาทร",
    "เขตบางซื่อ",
    "เขตจตุจักร",
    "เขตบางคอแหลม",
    "เขตประเวศ",
    "เขตคลองเตย",
    "เขตสวนหลวง",
    "เขตจอมทอง",
    "เขตดอนเมือง",
    "เขตราชเทวี",
    "เขตลาดพร้าว",
    "เขตวัฒนา",
    "เขตบางแค",
    "เขตหลักสี่",
    "เขตสายไหม",
    "เขตคันนายาว",
    "เขตสะพานสูง",
    "เขตวังทองหลาง",
    "เขตคลองสามวา",
    "เขตบางนา",
    "เขตทวีวัฒนา",
    "เขตทุ่งครุ",
    "เขตบางบอน"
  ],
  "สมุทรปราการ": [
    "เมืองสมุทรปราการ",
    "บางบ่อ",
    "บางพลี",
    "พระประแดง",
    "พระสมุทรเจดีย์",
    "บางเสาธง"
  ],
  "นนทบุรี": [
    "เมืองนนทบุรี",
    "บางกรวย",
    "บางใหญ่",
    "บางบัวทอง",
    "ไทรน้อย",
    "ปากเกร็ด"
  ],
  "ปทุมธานี": [
    "เมืองปทุมธานี",
    "คลองหลวง",
    "ธัญบุรี",
    "หนองเสือ",
    "ลาดหลุมแก้ว",
    "ลำลูกกา",
    "สามโคก"
  ],
  "พระนครศรีอยุธยา": [
    "พระนครศรีอยุธยา",
    "ท่าเรือ",
    "นครหลวง",
    "บางไทร",
    "บางบาล",
    "บางปะอิน",
    "บางปะหัน",
    "ผักไห่",
    "ภาชี",
    "ลาดบัวหลวง",
    "วังน้อย",
    "เสนา",
    "บางซ้าย",
    "อุทัย",
    "มหาราช",
    "บ้านแพรก"
  ],
  "อ่างทอง": [
    "เมืองอ่างทอง",
    "ไชโย",
    "ป่าโมก",
    "โพธิ์ทอง",
    "แสวงหา",
    "วิเศษชัยชาญ",
    "สามโก้"
  ],
  "ลพบุรี": [
    "เมืองลพบุรี",
    "พัฒนานิคม",
    "โคกสำโรง",
    "ชัยบาดาล",
    "ท่าวุ้ง",
    "บ้านหมี่",
    "ท่าหลวง",
    "สระโบสถ์",
    "โคกเจริญ",
    "ลำสนธิ",
    "หนองม่วง"
  ],
  "สิงห์บุรี": [
    "เมืองสิงห์บุรี",
    "บางระจัน",
    "ค่ายบางระจัน",
    "พรหมบุรี",
    "ท่าช้าง",
    "อินทร์บุรี"
  ],
  "ชัยนาท": [
    "เมืองชัยนาท",
    "มโนรมย์",
    "วัดสิงห์",
    "สรรพยา",
    "สรรคบุรี",
    "หันคา",
    "หนองมะโมง",
    "เนินขาม"
  ],
  "สระบุรี": [
    "เมืองสระบุรี",
    "แก่งคอย",
    "หนองแค",
    "วิหารแดง",
    "หนองแซง",
    "บ้านหมอ",
    "ดอนพุด",
    "หนองโดน",
    "พระพุทธบาท",
    "เสาไห้",
    "มวกเหล็ก",
    "วังม่วง",
    "เฉลิมพระเกียรติ"
  ],
  "ชลบุรี": [
    "เมืองชลบุรี",
    "บ้านบึง",
    "หนองใหญ่",
    "บางละมุง",
    "พานทอง",
    "พนัสนิคม",
    "ศรีราชา",
    "เกาะสีชัง",
    "สัตหีบ",
    "บ่อทอง",
    "เกาะจันทร์"
  ],
  "ระยอง": [
    "เมืองระยอง",
    "บ้านฉาง",
    "แกลง",
    "วังจันทร์",
    "บ้านค่าย",
    "ปลวกแดง",
    "เขาชะเมา",
    "นิคมพัฒนา"
  ],
  "จันทบุรี": [
    "เมืองจันทบุรี",
    "ขลุง",
    "ท่าใหม่",
    "โป่งน้ำร้อน",
    "มะขาม",
    "แหลมสิงห์",
    "สอยดาว",
    "แก่งหางแมว",
    "นายายอาม",
    "เขาคิชฌกูฏ"
  ],
  "ตราด": [
    "เมืองตราด",
    "คลองใหญ่",
    "เขาสมิง",
    "บ่อไร่",
    "แหลมงอบ",
    "เกาะกูด",
    "เกาะช้าง"
  ],
  "ฉะเชิงเทรา": [
    "เมืองฉะเชิงเทรา",
    "บางคล้า",
    "บางน้ำเปรี้ยว",
    "บางปะกง",
    "บ้านโพธิ์",
    "พนมสารคาม",
    "ราชสาส์น",
    "สนามชัยเขต",
    "แปลงยาว",
    "ท่าตะเกียบ",
    "คลองเขื่อน"
  ],
  "ปราจีนบุรี": [
    "เมืองปราจีนบุรี",
    "กบินทร์บุรี",
    "นาดี",
    "บ้านสร้าง",
    "ประจันตคาม",
    "ศรีมหาโพธิ",
    "ศรีมโหสถ"
  ],
  "นครนายก": [
    "เมืองนครนายก",
    "ปากพลี",
    "บ้านนา",
    "องครักษ์"
  ],
  "สระแก้ว": [
    "เมืองสระแก้ว",
    "คลองหาด",
    "ตาพระยา",
    "วังน้ำเย็น",
    "วัฒนานคร",
    "อรัญประเทศ",
    "เขาฉกรรจ์",
    "โคกสูง",
    "วังสมบูรณ์"
  ],
  "นครราชสีมา": [
    "เมืองนครราชสีมา",
    "ครบุรี",
    "เสิงสาง",
    "คง",
    "บ้านเหลื่อม",
    "จักราช",
    "โชคชัย",
    "ด่านขุนทด",
    "โนนไทย",
    "โนนสูง",
    "ขามสะแกแสง",
    "บัวใหญ่",
    "ประทาย",
    "ปักธงชัย",
    "พิมาย",
    "ห้วยแถลง",
    "ชุมพวง",
    "สูงเนิน",
    "ขามทะเลสอ",
    "สีคิ้ว",
    "ปากช่อง",
    "หนองบุญมาก",
    "แก้งสนามนาง",
    "โนนแดง",
    "วังน้ำเขียว",
    "เทพารักษ์",
    "เมืองยาง",
    "พระทองคำ",
    "ลำทะเมนชัย",
    "บัวลาย",
    "สีดา",
    "เฉลิมพระเกียรติ"
  ],
  "บุรีรัมย์": [
    "เมืองบุรีรัมย์",
    "คูเมือง",
    "กระสัง",
    "นางรอง",
    "หนองกี่",
    "ละหานทราย",
    "ประโคนชัย",
    "บ้านกรวด",
    "พุทไธสง",
    "ลำปลายมาศ",
    "สตึก",
    "ปะคำ",
    "นาโพธิ์",
    "หนองหงส์",
    "พลับพลาชัย",
    "ห้วยราช",
    "โนนสุวรรณ",
    "ชำนิ",
    "บ้านใหม่ไชยพจน์",
    "โนนดินแดง",
    "บ้านด่าน",
    "แคนดง",
    "เฉลิมพระเกียรติ"
  ],
  "สุรินทร์": [
    "เมืองสุรินทร์",
    "ชุมพลบุรี",
    "ท่าตูม",
    "จอมพระ",
    "ปราสาท",
    "กาบเชิง",
    "รัตนบุรี",
    "สนม",
    "ศีขรภูมิ",
    "สังขะ",
    "ลำดวน",
    "สำโรงทาบ",
    "บัวเชด",
    "พนมดงรัก",
    "ศรีณรงค์",
    "เขวาสินรินทร์",
    "โนนนารายณ์"
  ],
  "ศรีสะเกษ": [
    "เมืองศรีสะเกษ",
    "ยางชุมน้อย",
    "กันทรารมย์",
    "กันทรลักษ์",
    "ขุขันธ์",
    "ไพรบึง",
    "ปรางค์กู่",
    "ขุนหาญ",
    "ราษีไศล",
    "อุทุมพรพิสัย",
    "บึงบูรพ์",
    "ห้วยทับทัน",
    "โนนคูณ",
    "ศรีรัตนะ",
    "น้ำเกลี้ยง",
    "วังหิน",
    "ภูสิงห์",
    "เมืองจันทร์",
    "เบญจลักษ์",
    "พยุห์",
    "โพธิ์ศรีสุวรรณ",
    "ศิลาลาด"
  ],
  "อุบลราชธานี": [
    "เมืองอุบลราชธานี",
    "ศรีเมืองใหม่",
    "โขงเจียม",
    "เขื่องใน",
    "เขมราฐ",
    "เดชอุดม",
    "นาจะหลวย",
    "น้ำยืน",
    "บุณฑริก",
    "ตระการพืชผล",
    "กุดข้าวปุ้น",
    "ม่วงสามสิบ",
    "วารินชำราบ",
    "พิบูลมังสาหาร",
    "ตาลสุม",
    "โพธิ์ไทร",
    "สำโรง",
    "ดอนมดแดง",
    "สิรินธร",
    "ทุ่งศรีอุดม",
    "นาเยีย",
    "นาตาล",
    "เหล่าเสือโก้ก",
    "สว่างวีระวงศ์",
    "น้ำขุ่น"
  ],
  "ยโสธร": [
    "เมืองยโสธร",
    "ทรายมูล",
    "กุดชุม",
    "คำเขื่อนแก้ว",
    "ป่าติ้ว",
    "มหาชนะชัย",
    "ค้อวัง",
    "เลิงนกทา",
    "ไทยเจริญ"
  ],
  "ชัยภูมิ": [
    "เมืองชัยภูมิ",
    "บ้านเขว้า",
    "คอนสวรรค์",
    "เกษตรสมบูรณ์",
    "หนองบัวแดง",
    "จัตุรัส",
    "บำเหน็จณรงค์",
    "หนองบัวระเหว",
    "เทพสถิต",
    "ภูเขียว",
    "บ้านแท่น",
    "แก้งคร้อ",
    "คอนสาร",
    "ภักดีชุมพล",
    "เนินสง่า",
    "ซับใหญ่"
  ],
  "อำนาจเจริญ": [
    "เมืองอำนาจเจริญ",
    "ชานุมาน",
    "ปทุมราชวงศา",
    "พนา",
    "เสนางคนิคม",
    "หัวตะพาน",
    "ลืออำนาจ"
  ],
  "บึงกาฬ": [
    "เมืองบึงกาฬ",
    "เซกา",
    "โซ่พิสัย",
    "พรเจริญ",
    "ศรีวิไล",
    "บึงโขงหลง",
    "ปากคาด",
    "บุ่งคล้า"
  ],
  "หนองบัวลำภู": [
    "เมืองหนองบัวลำภู",
    "นากลาง",
    "โนนสัง",
    "ศรีบุญเรือง",
    "สุวรรณคูหา",
    "นาวัง"
  ],
  "ขอนแก่น": [
    "เมืองขอนแก่น",
    "บ้านฝาง",
    "พระยืน",
    "หนองเรือ",
    "ชุมแพ",
    "สีชมพู",
    "น้ำพอง",
    "อุบลรัตน์",
    "กระนวน",
    "บ้านไผ่",
    "เปือยน้อย",
    "พล",
    "แวงใหญ่",
    "แวงน้อย",
    "หนองสองห้อง",
    "ภูเวียง",
    "มัญจาคีรี",
    "ชนบท",
    "เขาสวนกวาง",
    "ภูผาม่าน",
    "ซำสูง",
    "โคกโพธิ์ไชย",
    "หนองนาคำ",
    "บ้านแฮด",
    "โนนศิลา",
    "เวียงเก่า"
  ],
  "อุดรธานี": [
    "เมืองอุดรธานี",
    "กุดจับ",
    "หนองวัวซอ",
    "กุมภวาปี",
    "โนนสะอาด",
    "หนองหาน",
    "ทุ่งฝน",
    "ไชยวาน",
    "ศรีธาตุ",
    "วังสามหมอ",
    "บ้านดุง",
    "บ้านผือ",
    "น้ำโสม",
    "เพ็ญ",
    "สร้างคอม",
    "หนองแสง",
    "นายูง",
    "พิบูลย์รักษ์",
    "กู่แก้ว",
    "ประจักษ์ศิลปาคม"
  ],
  "เลย": [
    "เมืองเลย",
    "นาด้วง",
    "เชียงคาน",
    "ปากชม",
    "ด่านซ้าย",
    "นาแห้ว",
    "ภูเรือ",
    "ท่าลี่",
    "วังสะพุง",
    "ภูกระดึง",
    "ภูหลวง",
    "ผาขาว",
    "เอราวัณ",
    "หนองหิน"
  ],
  "หนองคาย": [
    "เมืองหนองคาย",
    "ท่าบ่อ",
    "โพนพิสัย",
    "ศรีเชียงใหม่",
    "สังคม",
    "สระใคร",
    "เฝ้าไร่",
    "รัตนวาปี",
    "โพธิ์ตาก"
  ],
  "มหาสารคาม": [
    "เมืองมหาสารคาม",
    "แกดำ",
    "โกสุมพิสัย",
    "กันทรวิชัย",
    "เชียงยืน",
    "บรบือ",
    "นาเชือก",
    "พยัคฆภูมิพิสัย",
    "วาปีปทุม",
    "นาดูน",
    "ยางสีสุราช",
    "กุดรัง",
    "ชื่นชม"
  ],
  "ร้อยเอ็ด": [
    "เมืองร้อยเอ็ด",
    "เกษตรวิสัย",
    "ปทุมรัตต์",
    "จตุรพักตรพิมาน",
    "ธวัชบุรี",
    "พนมไพร",
    "โพนทอง",
    "โพธิ์ชัย",
    "หนองพอก",
    "เสลภูมิ",
    "สุวรรณภูมิ",
    "เมืองสรวง",
    "โพนทราย",
    "อาจสามารถ",
    "เมยวดี",
    "ศรีสมเด็จ",
    "จังหาร",
    "เชียงขวัญ",
    "หนองฮี",
    "ทุ่งเขาหลวง"
  ],
  "กาฬสินธุ์": [
    "เมืองกาฬสินธุ์",
    "นามน",
    "กมลาไสย",
    "ร่องคำ",
    "กุฉินารายณ์",
    "เขาวง",
    "ยางตลาด",
    "ห้วยเม็ก",
    "สหัสขันธ์",
    "คำม่วง",
    "ท่าคันโท",
    "หนองกุงศรี",
    "สมเด็จ",
    "ห้วยผึ้ง",
    "สามชัย",
    "นาคู",
    "ดอนจาน",
    "ฆ้องชัย"
  ],
  "สกลนคร": [
    "เมืองสกลนคร",
    "กุสุมาลย์",
    "กุดบาก",
    "พรรณานิคม",
    "พังโคน",
    "วาริชภูมิ",
    "นิคมน้ำอูน",
    "วานรนิวาส",
    "คำตากล้า",
    "บ้านม่วง",
    "อากาศอำนวย",
    "สว่างแดนดิน",
    "ส่องดาว",
    "เต่างอย",
    "โคกศรีสุพรรณ",
    "เจริญศิลป์",
    "โพนนาแก้ว",
    "ภูพาน"
  ],
  "นครพนม": [
    "เมืองนครพนม",
    "ปลาปาก",
    "ท่าอุเทน",
    "บ้านแพง",
    "ธาตุพนม",
    "เรณูนคร",
    "นาแก",
    "ศรีสงคราม",
    "นาหว้า",
    "โพนสวรรค์",
    "นาทม",
    "วังยาง"
  ],
  "มุกดาหาร": [
    "เมืองมุกดาหาร",
    "นิคมคำสร้อย",
    "ดอนตาล",
    "ดงหลวง",
    "คำชะอี",
    "หว้านใหญ่",
    "หนองสูง"
  ],
  "เชียงใหม่": [
    "เมืองเชียงใหม่",
    "จอมทอง",
    "แม่แจ่ม",
    "เชียงดาว",
    "ดอยสะเก็ด",
    "แม่แตง",
    "แม่ริม",
    "สะเมิง",
    "ฝาง",
    "แม่อาย",
    "พร้าว",
    "สันป่าตอง",
    "สันกำแพง",
    "สันทราย",
    "หางดง",
    "ฮอด",
    "ดอยเต่า",
    "อมก๋อย",
    "สารภี",
    "เวียงแหง",
    "ไชยปราการ",
    "แม่วาง",
    "แม่ออน",
    "ดอยหล่อ"
  ],
  "ลำพูน": [
    "เมืองลำพูน",
    "แม่ทา",
    "บ้านโฮ่ง",
    "ลี้",
    "ทุ่งหัวช้าง",
    "ป่าซาง",
    "บ้านธิ",
    "เวียงหนองล่อง"
  ],
  "ลำปาง": [
    "เมืองลำปาง",
    "แม่เมาะ",
    "เกาะคา",
    "เสริมงาม",
    "งาว",
    "แจ้ห่ม",
    "วังเหนือ",
    "เถิน",
    "แม่พริก",
    "แม่ทะ",
    "สบปราบ",
    "ห้างฉัตร",
    "เมืองปาน"
  ],
  "อุตรดิตถ์": [
    "เมืองอุตรดิตถ์",
    "ตรอน",
    "ท่าปลา",
    "น้ำปาด",
    "ฟากท่า",
    "บ้านโคก",
    "พิชัย",
    "ลับแล",
    "ทองแสนขัน"
  ],
  "แพร่": [
    "เมืองแพร่",
    "ร้องกวาง",
    "ลอง",
    "สูงเม่น",
    "เด่นชัย",
    "สอง",
    "วังชิ้น",
    "หนองม่วงไข่"
  ],
  "น่าน": [
    "เมืองน่าน",
    "แม่จริม",
    "บ้านหลวง",
    "นาน้อย",
    "ปัว",
    "ท่าวังผา",
    "เวียงสา",
    "ทุ่งช้าง",
    "เชียงกลาง",
    "นาหมื่น",
    "สันติสุข",
    "บ่อเกลือ",
    "สองแคว",
    "ภูเพียง",
    "เฉลิมพระเกียรติ"
  ],
  "พะเยา": [
    "เมืองพะเยา",
    "จุน",
    "เชียงคำ",
    "เชียงม่วน",
    "ดอกคำใต้",
    "ปง",
    "แม่ใจ",
    "ภูซาง",
    "ภูกามยาว"
  ],
  "เชียงราย": [
    "เมืองเชียงราย",
    "เวียงชัย",
    "เชียงของ",
    "เทิง",
    "พาน",
    "ป่าแดด",
    "แม่จัน",
    "เชียงแสน",
    "แม่สาย",
    "แม่สรวย",
    "เวียงป่าเป้า",
    "พญาเม็งราย",
    "เวียงแก่น",
    "ขุนตาล",
    "แม่ฟ้าหลวง",
    "แม่ลาว",
    "เวียงเชียงรุ้ง",
    "ดอยหลวง"
  ],
  "แม่ฮ่องสอน": [
    "เมืองแม่ฮ่องสอน",
    "ขุนยวม",
    "ปาย",
    "แม่สะเรียง",
    "แม่ลาน้อย",
    "สบเมย",
    "ปางมะผ้า"
  ],
  "นครสวรรค์": [
    "เมืองนครสวรรค์",
    "โกรกพระ",
    "ชุมแสง",
    "หนองบัว",
    "บรรพตพิสัย",
    "เก้าเลี้ยว",
    "ตาคลี",
    "ท่าตะโก",
    "ไพศาลี",
    "พยุหะคีรี",
    "ลาดยาว",
    "ตากฟ้า",
    "แม่วงก์",
    "แม่เปิน",
    "ชุมตาบง"
  ],
  "อุทัยธานี": [
    "เมืองอุทัยธานี",
    "ทัพทัน",
    "สว่างอารมณ์",
    "หนองฉาง",
    "หนองขาหย่าง",
    "บ้านไร่",
    "ลานสัก",
    "ห้วยคต"
  ],
  "กำแพงเพชร": [
    "เมืองกำแพงเพชร",
    "ไทรงาม",
    "คลองลาน",
    "ขาณุวรลักษบุรี",
    "คลองขลุง",
    "พรานกระต่าย",
    "ลานกระบือ",
    "ทรายทองวัฒนา",
    "ปางศิลาทอง",
    "บึงสามัคคี",
    "โกสัมพีนคร"
  ],
  "ตาก": [
    "เมืองตาก",
    "บ้านตาก",
    "สามเงา",
    "แม่ระมาด",
    "ท่าสองยาง",
    "แม่สอด",
    "พบพระ",
    "อุ้มผาง",
    "วังเจ้า"
  ],
  "สุโขทัย": [
    "เมืองสุโขทัย",
    "บ้านด่านลานหอย",
    "คีรีมาศ",
    "กงไกรลาศ",
    "ศรีสัชนาลัย",
    "ศรีสำโรง",
    "สวรรคโลก",
    "ศรีนคร",
    "ทุ่งเสลี่ยม"
  ],
  "พิษณุโลก": [
    "เมืองพิษณุโลก",
    "นครไทย",
    "ชาติตระการ",
    "บางระกำ",
    "บางกระทุ่ม",
    "พรหมพิราม",
    "วัดโบสถ์",
    "วังทอง",
    "เนินมะปราง"
  ],
  "พิจิตร": [
    "เมืองพิจิตร",
    "วังทรายพูน",
    "โพธิ์ประทับช้าง",
    "ตะพานหิน",
    "บางมูลนาก",
    "โพทะเล",
    "สามง่าม",
    "ทับคล้อ",
    "สากเหล็ก",
    "บึงนาราง",
    "ดงเจริญ",
    "วชิรบารมี"
  ],
  "เพชรบูรณ์": [
    "เมืองเพชรบูรณ์",
    "ชนแดน",
    "หล่มสัก",
    "หล่มเก่า",
    "วิเชียรบุรี",
    "ศรีเทพ",
    "หนองไผ่",
    "บึงสามพัน",
    "น้ำหนาว",
    "วังโป่ง",
    "เขาค้อ"
  ],
  "ราชบุรี": [
    "เมืองราชบุรี",
    "จอมบึง",
    "สวนผึ้ง",
    "ดำเนินสะดวก",
    "บ้านโป่ง",
    "บางแพ",
    "โพธาราม",
    "ปากท่อ",
    "วัดเพลง",
    "บ้านคา",
    "ท้องถิ่นเทศบาลตำบลบ้านฆ้อง"
  ],
  "กาญจนบุรี": [
    "เมืองกาญจนบุรี",
    "ไทรโยค",
    "บ่อพลอย",
    "ศรีสวัสดิ์",
    "ท่ามะกา",
    "ท่าม่วง",
    "ทองผาภูมิ",
    "สังขละบุรี",
    "พนมทวน",
    "เลาขวัญ",
    "ด่านมะขามเตี้ย",
    "หนองปรือ",
    "ห้วยกระเจา"
  ],
  "สุพรรณบุรี": [
    "เมืองสุพรรณบุรี",
    "เดิมบางนางบวช",
    "ด่านช้าง",
    "บางปลาม้า",
    "ศรีประจันต์",
    "ดอนเจดีย์",
    "สองพี่น้อง",
    "สามชุก",
    "อู่ทอง",
    "หนองหญ้าไซ"
  ],
  "นครปฐม": [
    "เมืองนครปฐม",
    "กำแพงแสน",
    "นครชัยศรี",
    "ดอนตูม",
    "บางเลน",
    "สามพราน",
    "พุทธมณฑล"
  ],
  "สมุทรสาคร": [
    "เมืองสมุทรสาคร",
    "กระทุ่มแบน",
    "บ้านแพ้ว"
  ],
  "สมุทรสงคราม": [
    "เมืองสมุทรสงคราม",
    "บางคนที",
    "อัมพวา"
  ],
  "เพชรบุรี": [
    "เมืองเพชรบุรี",
    "เขาย้อย",
    "หนองหญ้าปล้อง",
    "ชะอำ",
    "ท่ายาง",
    "บ้านลาด",
    "บ้านแหลม",
    "แก่งกระจาน"
  ],
  "ประจวบคีรีขันธ์": [
    "เมืองประจวบคีรีขันธ์",
    "กุยบุรี",
    "ทับสะแก",
    "บางสะพาน",
    "บางสะพานน้อย",
    "ปราณบุรี",
    "หัวหิน",
    "สามร้อยยอด"
  ],
  "นครศรีธรรมราช": [
    "เมืองนครศรีธรรมราช",
    "พรหมคีรี",
    "ลานสกา",
    "ฉวาง",
    "พิปูน",
    "เชียรใหญ่",
    "ชะอวด",
    "ท่าศาลา",
    "ทุ่งสง",
    "นาบอน",
    "ทุ่งใหญ่",
    "ปากพนัง",
    "ร่อนพิบูลย์",
    "สิชล",
    "ขนอม",
    "หัวไทร",
    "บางขัน",
    "ถ้ำพรรณรา",
    "จุฬาภรณ์",
    "พระพรหม",
    "นบพิตำ",
    "ช้างกลาง",
    "เฉลิมพระเกียรติ"
  ],
  "กระบี่": [
    "เมืองกระบี่",
    "เขาพนม",
    "เกาะลันตา",
    "คลองท่อม",
    "อ่าวลึก",
    "ปลายพระยา",
    "ลำทับ",
    "เหนือคลอง"
  ],
  "พังงา": [
    "เมืองพังงา",
    "เกาะยาว",
    "กะปง",
    "ตะกั่วทุ่ง",
    "ตะกั่วป่า",
    "คุระบุรี",
    "ทับปุด",
    "ท้ายเหมือง"
  ],
  "ภูเก็ต": [
    "เมืองภูเก็ต",
    "กะทู้",
    "ถลาง"
  ],
  "สุราษฎร์ธานี": [
    "เมืองสุราษฎร์ธานี",
    "กาญจนดิษฐ์",
    "ดอนสัก",
    "เกาะสมุย",
    "เกาะพะงัน",
    "ไชยา",
    "ท่าชนะ",
    "คีรีรัฐนิคม",
    "บ้านตาขุน",
    "พนม",
    "ท่าฉาง",
    "บ้านนาสาร",
    "บ้านนาเดิม",
    "เคียนซา",
    "เวียงสระ",
    "พระแสง",
    "พุนพิน",
    "ชัยบุรี",
    "วิภาวดี"
  ],
  "ระนอง": [
    "เมืองระนอง",
    "ละอุ่น",
    "กะเปอร์",
    "กระบุรี",
    "สุขสำราญ"
  ],
  "ชุมพร": [
    "เมืองชุมพร",
    "ท่าแซะ",
    "ปะทิว",
    "หลังสวน",
    "ละแม",
    "พะโต๊ะ",
    "สวี",
    "ทุ่งตะโก"
  ],
  "สงขลา": [
    "เมืองสงขลา",
    "สทิงพระ",
    "จะนะ",
    "นาทวี",
    "เทพา",
    "สะบ้าย้อย",
    "ระโนด",
    "กระแสสินธุ์",
    "รัตภูมิ",
    "สะเดา",
    "หาดใหญ่",
    "นาหม่อม",
    "ควนเนียง",
    "บางกล่ำ",
    "สิงหนคร",
    "คลองหอยโข่ง",
    "ท้องถิ่นเทศบาลตำบลสำนักขาม"
  ],
  "สตูล": [
    "เมืองสตูล",
    "ควนโดน",
    "ควนกาหลง",
    "ท่าแพ",
    "ละงู",
    "ทุ่งหว้า",
    "มะนัง"
  ],
  "ตรัง": [
    "เมืองตรัง",
    "กันตัง",
    "ย่านตาขาว",
    "ปะเหลียน",
    "สิเกา",
    "ห้วยยอด",
    "วังวิเศษ",
    "นาโยง",
    "รัษฎา",
    "หาดสำราญ"
  ],
  "พัทลุง": [
    "เมืองพัทลุง",
    "กงหรา",
    "เขาชัยสน",
    "ตะโหมด",
    "ควนขนุน",
    "ปากพะยูน",
    "ศรีบรรพต",
    "ป่าบอน",
    "บางแก้ว",
    "ป่าพะยอม",
    "ศรีนครินทร์"
  ],
  "ปัตตานี": [
    "เมืองปัตตานี",
    "โคกโพธิ์",
    "หนองจิก",
    "ปะนาเระ",
    "มายอ",
    "ทุ่งยางแดง",
    "สายบุรี",
    "ไม้แก่น",
    "ยะหริ่ง",
    "ยะรัง",
    "กะพ้อ",
    "แม่ลาน"
  ],
  "ยะลา": [
    "เมืองยะลา",
    "เบตง",
    "บันนังสตา",
    "ธารโต",
    "ยะหา",
    "รามัน",
    "กาบัง",
    "กรงปินัง"
  ],
  "นราธิวาส": [
    "เมืองนราธิวาส",
    "ตากใบ",
    "บาเจาะ",
    "ยี่งอ",
    "ระแงะ",
    "รือเสาะ",
    "ศรีสาคร",
    "แว้ง",
    "สุคิริน",
    "สุไหงโก-ลก",
    "สุไหงปาดี",
    "จะแนะ",
    "เจาะไอร้อง"
  ]
};

export default provinces;